<script>
    import InlineEdit from "../../../../../components/inline-edit.svelte";
    import AssetsApi from "../../../service.js";
    import { format } from "svelte-i18n";
    import { tick } from "svelte";
    import { notificate } from "../../../../../services/notification";

    let { asset = {}, navigation = false } = $props();
    let tooltipID = $state();
    let in_scope_checkbox = $derived.by(() => asset.in_scope);
    let auto_delete_checkbox = $derived.by(() => asset.auto_delete);
    let inputElement = $state();
    let autoDeleteInputElement = $state();

    let showHelp = $state({
        persistent: false,
        mouseover: false,
    });

    const handleSaveFn = (data, attribute) => {
        return ({ detail: input }) => {
            let newAsset = {
                id: data.id,
            };
            if (attribute == "in_scope") {
                newAsset.in_scope = !in_scope_checkbox;
            } else if (attribute == "auto_delete") {
                newAsset.auto_delete = !auto_delete_checkbox;
            } else {
                newAsset[attribute] = input.value;
            }

            AssetsApi.save(newAsset, [], {}, false)
                .then((pAsset) => {
                    if (newAsset.in_scope && !pAsset.in_scope) {
                        notificate("limitReached");
                    } else {
                        notificate("save_ok", "toast", { data: pAsset.name });
                    }
                    asset = pAsset;
                })
                .catch(() => {
                    return false;
                });
        };
    };

    const handleCopy = async (str, tooltip) => {
        copyText(str, tooltip);
    };

    const copyText = async (str, tooltip) => {
        await tick();
        if ("clipboard" in navigator) {
            navigator.clipboard
                .writeText(str)
                .then(() => {
                    showTooltip(tooltip);
                    hideTooltip(tooltip);
                })
                .catch((err) => console.error(err.name, err.message));
        } else {
            let selBox = document.createElement("textarea");
            selBox.style.position = "fixed";
            selBox.style.left = "0";
            selBox.style.top = "0";
            selBox.style.opacity = "0";
            selBox.value = str;
            document.body.appendChild(selBox);
            selBox.focus();
            selBox.select();
            // @TODO: upgrade to clipboard API
            try {
                const success = document.execCommand("copy");
            } catch (err) {
                return false;
            }
            showTooltip(tooltip);
            document.body.removeChild(selBox);
            hideTooltip(tooltip);
        }
    };

    const hideTooltip = (tooltip) => {
        setTimeout(() => {
            tooltip.classList.add("trigger-opacity-cero");
            tooltip.classList.remove("trigger-opacity-one");
            setTimeout(() => tooltip.classList.add("d-none"), 1000);
        }, 2000);
    };

    const showTooltip = (tooltip) => {
        tooltip.classList.remove("d-none");
        setTimeout(() => {
            tooltip.classList.remove("trigger-opacity-cero");
            tooltip.classList.add("trigger-opacity-one");
        }, 1000);
    };

    // InlineEdit options
    let inlineEdit = {
        type: "text",
        placeholder: $format("add_desc"),
        lang: {
            edit: $format("buttons.edit"),
            save: $format("buttons.save"),
            cancel: $format("buttons.cancel"),
        },
    };
</script>

{#if JSON.stringify($state.snapshot(asset)) != "{}"}
    <div class="d-flex flex-container-2item">
        <div>
            <div><strong>{$format("list.columns.name")}</strong></div>
            {#if asset.name}
                {#if navigation}
                    <a href={`/asset/${asset.kind}/${asset.id}/`}
                        >{asset.nickname || asset.name || ""}</a
                    >
                {:else}
                    {asset.nickname || asset.name || ""}
                {/if}
            {:else}
                <div class="overlay justify-content-start">
                    <i class="fas fa-sync-alt fa-spin"></i>
                </div>
            {/if}
        </div>
        <div class="">
            <div><strong>{$format("list.columns.description")}</strong></div>
            {#if asset.hasOwnProperty("description")}
                <InlineEdit
                    {...inlineEdit}
                    value={asset.description}
                    on:save={handleSaveFn(asset, "description")}
                />
            {:else}
                <div class="overlay justify-content-start">
                    <i class="fas fa-sync-alt fa-spin"></i>
                </div>
            {/if}
        </div>
    </div>
    <div class="d-flex flex-container-2item mt-3">
        <div class="mt-3">
            <div><strong>{$format("list.columns.in_scope")}</strong></div>
            {#if asset.hasOwnProperty("in_scope")}
                {#if asset && !asset.in_scope && asset.third_party}
                    <i class="fa fa-eye-slash"></i> <i class="fa fa-cloud"></i>
                {:else}
                    <div class="form-check form-switch">
                        <input
                            type="checkbox"
                            bind:this={inputElement}
                            bind:checked={in_scope_checkbox}
                            onclick={handleSaveFn(asset, "in_scope")}
                            class="form-check-input"
                            id={"switch_in_scope" + asset.id}
                        />
                        <label
                            class="custom-control-label"
                            for={"switch_in_scope" + asset.id}
                        ></label>
                    </div>
                {/if}
            {:else}
                <div class="overlay justify-content-start">
                    <i class="fas fa-sync-alt fa-spin"></i>
                </div>
            {/if}
        </div>
        <div class="mt-3">
            {#if asset.hasOwnProperty("third_party") && asset.third_party}
                <div style="position: relative; max-width: 10em;">
                    <strong
                        >{$format(
                            "page.asset.form.warnings.managed_by",
                        )}</strong
                    >
                    <i
                        class="ms-2 mt-2 icon-help help-btn far fa-question-circle"
                        class:showHelp={showHelp.persistent ||
                            showHelp.mouseover}
                        onclick={() =>
                            (showHelp.persistent = !showHelp.persistent)}
                        onmouseover={() =>
                            (showHelp.mouseover = !showHelp.mouseover)}
                        onfocus={() =>
                            (showHelp.mouseover = !showHelp.mouseover)}
                        onmouseleave={() =>
                            (showHelp.mouseover = !showHelp.mouseover)}
                    ></i>
                    <div>
                        {$format("page.asset.form.warnings.third_party_detail")}
                    </div>
                </div>

                <div>{asset.third_party}</div>
            {/if}
        </div>
    </div>
    <div class="d-flex align-items-center flex-container-2item mt-3">
        <div>
            {#key asset.auto_delete}<div class="d-flex">
                    <strong style="max-width: fit-content;"
                        >{$format("asset.auto_delete_title")}</strong
                    ><i
                        style="top: -5px !important;"
                        title={$format("asset.auto_delete_helper")}
                        class="ms-2 mt-2 icon-help help-btn far fa-question-circle"
                    ></i>
                </div>{/key}
            {#if asset.hasOwnProperty("auto_delete")}
                {#if asset.kind != "domain" && !asset.kind.includes("network")}
                    <div class="form-check form-switch">
                        <input
                            type="checkbox"
                            bind:this={autoDeleteInputElement}
                            bind:checked={auto_delete_checkbox}
                            onclick={handleSaveFn(asset, "auto_delete")}
                            class="form-check-input"
                            id={"switch_auto_delete" + asset.id}
                        />
                        <label
                            class="custom-control-label"
                            for={"switch_auto_delete" + asset.id}
                        ></label>
                    </div>
                {:else}
                    <div>{$format("asset.manual_delete")}</div>
                {/if}
            {/if}
        </div>
        <div>
            <div><strong>{$format("list.columns.is_dynamic")}</strong></div>
            {#if !asset.is_dynamic}
                <div class="d-flex align-items-center">
                    {$format("asset.is_not_dynamic")}&nbsp;<i
                        title={$format("asset.is_not_dynamic")}
                        class="fas fa-user"
                        style="margin-bottom: 3px !important;"
                    ></i>
                </div>
            {:else}
                <div class="d-flex align-items-center">
                    {$format("asset.is_dynamic")}&nbsp;<i
                        title={$format("asset.is_dynamic")}
                        class="fas fa-cogs"
                    ></i>
                </div>
            {/if}
        </div>
    </div>
    <div class="d-flex flex-container-2item mt-3">
        <div>
            <div><strong>ID</strong></div>
            {#if asset.id}
                {asset.id || ""}
                <button
                    class="btn btn-copy far fa-copy"
                    title="Copiar al portapapeles"
                    aria-label="Copiar"
                    style="position: relative; top: -2px;"
                    onclick={() => handleCopy(asset.id, tooltipID)}
                ></button>
                <span
                    id="tooltip-compose"
                    class="d-none trigger-opacity-cero copy-tooltip"
                    bind:this={tooltipID}>{$format("copied")}</span
                >
            {:else}
                <div class="overlay justify-content-start">
                    <i class="fas fa-sync-alt fa-spin"></i>
                </div>
            {/if}
        </div>
    </div>
{:else}
    <div class="card-body">
        <div class="d-flex flex-container-2item">
            <div>{$format("notifications.resource_not_found")}</div>
        </div>
    </div>
{/if}

<style>
    .d-flex > * {
        flex: 1;
    }

    .d-flex > i.icon-help,
    .d-flex > i.fas.fa-cogs {
        flex: 0;
    }
    .flex-container-2item div:first-child {
        flex: 2;
    }

    .help-btn {
        position: relative;
        top: -3px;
    }

    .help-btn + div {
        display: none;
        position: absolute;
        background: rgb(0, 0, 0, 0.8);
        border-radius: 5px;
        color: white;
        padding: 15px;
        top: -83px;
        right: -17px;
        width: 410px;
    }

    .help-btn + div:after {
        content: "";
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid rgba(0, 0, 0, 0.8);
        position: absolute;
        bottom: -7px;
        right: 16px;
    }

    .help-btn.showHelp + div {
        display: block;
    }
</style>
